
    $(document).ready(function(){
        $("#chcbox").click(function(){
            if ( $('#chcbox').is(':checked')){

              	$('#sendbtn').css("opacity","1");
              	$('#sendbtn').css("pointer-events","auto");
              	$('#sendbtn').css("cursor","pointer");
            }
            else
            {
                
              	$('#sendbtn').css("opacity",".2");
              	$('#sendbtn').css("pointer-events","none");
              	$('#sendbtn').css("cursor","not-allowed");
            }
        });
    });